export function pushOneSignalTracking(
  event: string,
  data: Record<string, unknown>
): void {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({ event: 'onesignal-tracking', param: { ...data, event } })
  )
}
